// extracted by mini-css-extract-plugin
module.exports = {"file":"clinical-portal-3__FileDownload__file","icon":"clinical-portal-3__FileDownload__icon","label":"clinical-portal-3__FileDownload__label"};